﻿//The bundle.ts is the main bundle 

//Import styles
import 'nouislider/distribute/nouislider.css'; 
import 'simplelightbox/dist/simple-lightbox.css'; 
import './scss/site.scss';
import './scss/main.scss';



//Import scripts
import './fonts/fontawesome/js/fontawesome.js';
import './fonts/fontawesome/js/light.js';
import './fonts/fontawesome/js/regular.js';
import './fonts/fontawesome/js/brands.js';
import './scripts/main';



